// Ensure fetch is available (no need to import whatwg-fetch in modern browsers)
if (typeof fetch === 'undefined') {
  console.warn('[callApi] fetch is undefined - attempting to load polyfill');
  try {
    require('whatwg-fetch');
  } catch (e) {
    console.error('[callApi] Failed to load whatwg-fetch polyfill:', e);
  }
}

import { getToken } from "../../utils/authn";

const callApi = (url, { headers, ...options } = {}) => {
  // Ensure fetch is a function
  if (typeof fetch !== 'function') {
    const error = new Error(`fetch is not available (type: ${typeof fetch})`);
    return Promise.reject(error);
  }

  const fetchOptions = {
    headers: headers || {},
    ...options,
    ...{ mode: "cors" }
  };

  const token = getToken();
  if (token) {
    fetchOptions.headers["Authorization"] = `Bearer ${token}`;
  }

  return fetch(url, fetchOptions)
    .then(r => {
      if (r.ok) {
        return r.json();
      } else {
        return r.text().then(text => {
          const body = text ? JSON.parse(text) : undefined;
          const error = new Error();
          if (r.status) {
            error.status = r.status;
          }
          if (typeof body !== "undefined") {
            error.body = body.error;
          }
          throw error;
        });
      }
    })
    .catch(e => {
      throw e;
    });
};

export { callApi };
